<div class="glam-home-banner-warning" *ngIf="showWarning && endDate">
  <b>Atenção!</b> No dia
  <b>{{ endDate | date : 'dd/MM/yyyy' }} as {{ endDate | date : 'HH:mm' }}</b>
  todos os banners serão excluídos. Lembre-se de incluir um novo banner ou
  alterar o agendamento até esta data.
</div>
